/** @jsxImportSource @emotion/react */
import React from "react";
import { Outlet } from "react-router-dom";
import { css } from "@emotion/react";
import { Header } from "./Header/Header";
import { Footer } from "./Footer/Footer";
import SubscribeSection from "../banners/SubscribeSection";

const pageStyle = css`
  min-height: 100vh;
  // background: #0f0f10; /* общий фон под luxury стиль */
`;

const contentStyle = css`
  max-width: 1320px;
  margin: 0 auto;
  padding: 0;
`;

export const MainLayout: React.FC = () => {
  return (
    <div css={pageStyle}>
      <Header />
      <main css={contentStyle}>
        <Outlet />
      </main>
      <SubscribeSection />
      <Footer />
    </div>
  );
};
